import http from './api'

const url = '/dashboard'

export const httpGetDashboardTopNavigationButtons = (params) => {
  return http({
    url: `${url}/top_navigation_buttons/`,
    method: 'GET',
    params,
  })
}
